import React, { Component } from 'react';
import './styles/profile.css';
import firebase, { auth, provider } from './firebase'
import brandBanner from "./images/logo.png"
export default class Profile extends Component {
    constructor() {
        super();
        this.state = {
            skill: '',
            username: '',
            items: [],
            user: null
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    removeItem(itemId) {
        const itemref = firebase.database().ref(`/masters/${itemId}`);
        itemref.remove();
    }
    componentDidMount() {
        const itemref = firebase.database().ref('masters');
        itemref.on('value', (snapshot) => {
            let items = snapshot.val();
            let newState = [];
            for (let item in items) {
                newState.push({
                    id: item,
                    username: items[item].username,
                    email: items[item].email,
                    skills: {
                        name: items[item].skills.name,
                        level: items[item].skills.level
                    }
                });
            }
            this.setState({
                items: newState
            });
        })
    }
    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }
    handleSubmit(e) {
        e.preventDefault();
        const itemref = firebase.database().ref('masters');
        const item = {
            skills: {
                name: this.state.skill,
                level: this.state.skillLevel
            },
            username: this.props.AuthState.user.displayName,
            email: this.props.AuthState.user.email
        }
        itemref.push(item);
        this.setState({
            skill: '',
            skillLevel: ''
        })
    }
    render() {
        return (
            <div className="row-fluid">
                <br></br>
                <img src={brandBanner} className="img-fluid" style={{ height: "64px" }}></img>
                <br></br><br></br>
                <p>
                    On SkillEd, you can make new friends and learn new skills along the way. You can also mentor others in things you are good at. With SkillEd, we bring the personal touch to skill sharing.
                </p>
                <hr></hr>
                <div className="row">
                    <div className="col-sm-2" style={{ margin: 0, padding: 0 }}>
                        <img alt="person" src={this.props.AuthState.user.photoURL} className="img-fluid rounded-circle" id="profilePic"></img>
                    </div>
                    <div className="col-sm-5">
                        <br></br>
                        <h1>{this.props.AuthState.user.displayName}</h1>
                        <span class="fa fa-star checked"></span>
                        <span class="fa fa-star checked"></span>
                        <span class="fa fa-star checked"></span>
                        <span class="fa fa-star checked"></span>
                        <span class="fa fa-star"></span>
                        <br></br>
                        <h6>Atlanta, GA, United States</h6>
                    </div>
                    <div className="col-sm-5" style={{ textAlign: "right" }}>
                        <br></br>
                        <h1>{parseInt(5000 * Math.random())}</h1>
                        <h6>22</h6>
                        <h6>11</h6>
                        <br></br>
                    </div>
                </div>
                <hr></hr><br></br>
                <h3>Skills</h3>
                {this.state.items.map((item) => {
                    return (
                        <div>
                            {item.email == this.props.AuthState.user.email || item.username == this.props.AuthState.user.displayName ?
                                <div className="row" style={{ display: "flex", alignItems: "center" }} key={item.id}>
                                    <div className="col-sm-11">
                                        <div className="progress" style={{ margin: 0 }}>
                                            <div className="progress-bar" role="progressbar" style={{ width: item.skills.level + "%" }} aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" >
                                                {item.skills.name}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-1">
                                        <button className="btn btn-link" style={{ padding: 0, margin: 0, color: "red" }} onClick={() => this.removeItem(item.id)}><i className="fa fa-minus"></i></button>
                                    </div>
                                </div>
                                :
                                <div></div>
                            }
                        </div>
                    )
                })}
                <hr></hr>
                <form onSubmit={this.handleSubmit}>
                    <div className="form-inline form-group" style={{ display: "flex", alignItems: "center" }} >
                        <div className="col">
                            <input type="text" style={{ margin: 0 }} className="form-control" name="skill" placeholder="Add New Skill" onChange={this.handleChange} value={this.state.skill} /><br />
                        </div>
                        <div className="col-sm-7"><input style={{ width: "100%" }} type="range" name="skillLevel" class="form-control-range" onChange={this.handleChange} value={this.state.skillLevel} /></div>
                        <div className="col-sm-1">
                            <button className="btn btn-link" style={{ color: "green" }}><i className="fa fa-plus"></i></button>
                        </div>
                    </div>
                </form>
                <hr></hr>
                <br></br>
                <h3>Basic Information</h3>
                <form onSubmit={this.handleSubmit}>
                    <div className="row" >
                        <div className="col">
                            <h6>Age : 23</h6>
                        </div>
                        <div className="col">
                            <h6>Gender : M</h6>
                        </div>
                    </div>
                    <div className="row" style={{ display: "flex", alignItems: "center" }} >
                        <div className="col">
                            <h6>City : Atlanta</h6>
                        </div>
                        <div className="col">
                            <h6>Country : United States</h6>
                        </div>
                    </div>
                </form>
                <br></br><br></br><br></br><br></br>
            </div>
        );
    }
}